import { Box, Heading, Image, VStack } from "@chakra-ui/react"

interface SatelliteViewProps {
  lat: string
  lng: string
  address: string
  zoom?: number
  showTitle?: boolean
  satelliteImageUrl?: string
}

const SatelliteView = ({
  lat,
  lng,
  address,
  zoom = 20,
  showTitle = true,
  satelliteImageUrl
}: SatelliteViewProps) => {
  return (
    <Box bg="white" p={6}>
      <VStack gap={4} align="stretch">
        {showTitle && <Heading size="lg">Satellite View</Heading>}
        {process.env.REACT_APP_GOOGLE_MAPS_API_KEY ? (
          <Image
            src={
              satelliteImageUrl ||
              `https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lng}&zoom=${zoom}&size=600x400&maptype=satellite&markers=color:red|${lat},${lng}&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`
            }
            alt={`Satellite view of ${address}`}
            borderRadius="md"
            width="100%"
            onError={(e) => {
              e.currentTarget.src =
                "https://via.placeholder.com/500x300/cccccc/666666?text=Satellite+View+Not+Available"
            }}
          />
        ) : (
          <Box
            bg="gray.200"
            p={8}
            borderRadius="md"
            textAlign="center"
            color="gray.600"
          >
            Satellite view requires Google Maps API key
          </Box>
        )}
      </VStack>
    </Box>
  )
}

export default SatelliteView
